import Vue from 'vue';

Vue.component('distributor-index', () =>
    import(/* webpackChunkName: 'distributor-index' */ './distributor-index.vue'),
);
